import React from 'react';
import SubNavbar from '../components/SubNavbar';
import ContactBox from '../components/ContactBox';
const Books = () => {
  return (
    <div className="white-page">
      <SubNavbar />
      <ContactBox />
      
      <div className="page-content-wrapper">
        <div className="photo-collections">
          <div className="book-year">
            <strong>2026</strong>
          </div>
          <div className="book-title">
            The Poisonwood Bible . Barbara Kingsolver
          </div>
          <div className="book-spacer">
            <br></br>
          </div>
          
          <div className="book-year">
            <strong>2025</strong>
          </div>
          <div className="book-title">
            Project Hail Mary . Andy Weir*
          </div>
          <div className="book-title">
            On the Shortness of Life . Seneca
          </div>
          <div className="book-title">
            The Stranger . Albert Camus
          </div>
          <div className="book-title">
            Life 3.0 . Max Tegmark
          </div>
          <div className="book-title">
            2001: A Space Odyssey . Arthur C. Clarke
          </div>
          <div className="book-title">
            White Nights . Fyodor Dostoevsky*
          </div>
          <div className="book-title">
            How We Learn . Stanislas Dehaene
          </div>
          <div className="book-title">
            A Monster Calls . Patrick Ness
          </div>
          <div className="book-title">
            Notes from Underground . Fyodor Dostoevsky
          </div>          
          <div className="book-title">
            Letters to a Young Poet . Rainer Maria Rilke*
          </div>          
          <div className="book-title">
            Blood Meridian . Cormac McCarthy*
          </div>          
          <div className="book-title">
            The Worlds I See . Fei-Fei Li
          </div>          
          <div className="book-title">
            Flowers for Algernon . Daniel Keyes
          </div>
          <div className="book-title">
            Neuromancer . William Gibson
          </div>
          <div className="book-spacer">
            <br></br>
          </div>
          <div className="book-recommendation">
            *I Highly Recommend!
          </div>
        </div>
      </div>
    </div>
  );
};
export default Books;
